export const NODE_IDS = {
  appScrollable: 'app-wrapper-scrollable',
};

// Using as functions ensures regex is always safe
export const REGEX = {
  // EMAIL: () => /^[\w-.]+@([\w-]+\.)+\w+$/i,
  EMAIL: () => /^[a-zA-Z0-9][a-zA-Z0-9._%+-]*@([a-zA-Z0-9]+(-[a-zA-Z0-9]+)*\.)+[a-zA-Z]{2,}$/,

  NAME: () => /^(?=(?:[^\p{L}]*\p{L}){3})[\p{L}'’-]+(?:\s+(?=(?:[^\p{L}]*\p{L}){3})[\p{L}'’-]+)+$/u,

  NON_NUMERIC_GLOBAL: () => /\D/g,
  ALL_NUMERIC: () => /^\d$/g,

  /*
    https://www.regextester.com/96504
  */
  LINK: () =>
    /(?:(?:https?|ftp):\/\/|\b(?:[a-z\d]+\.))(?:(?:[^\s()<>]+|\((?:[^\s()<>]+|(?:\([^\s()<>]+\)))?\))+(?:\((?:[^\s()<>]+|(?:\(?:[^\s()<>]+\)))?\)|[^\s`!()[\]{};:'".,<>?«»“”‘’]))?/i,

  URL: () =>
    /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi,
};

/**
 * Only the ones we may apply custom flow
 */
export const COUNTRY_CONFIGS = {
  CO: {
    pqrPolicy: true,
  },

  US: {
    languages: ['en', 'es'],
  },

  ES: {
    paymentPolicy: true,
    cookiePolicy: true,
  },
} as {
  [K in string]?: {
    pqrPolicy?: boolean;
    paymentPolicy?: boolean;
    cookiePolicy?: boolean;
    languages?: string[];
  };
};
